import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { trigger, transition, useAnimation } from '@angular/animations';
import { fadeInAnimation } from '../animations';
import { NavigationButtonService, NavigationButton } from '../navigation-button/navigation-button.service';

@Component({
  selector: 'app-navigation-panel',
  templateUrl: './navigation-panel.component.html',
  styleUrls: ['./navigation-panel.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', useAnimation(fadeInAnimation))
    ])
  ]
})
export class NavigationPanelComponent implements OnInit {

  constructor(private router: Router,
    private route: ActivatedRoute,
    private navigationButtonService: NavigationButtonService
  ) { }

  buttons = [];

  ngOnInit() {
    const path = this.route.firstChild.routeConfig.path;
    this.navigationButtonService.getButtons()
      .subscribe(buttons => {
        this.buttons = buttons;
        this.buttons.forEach(b => b.isSelected = (b.route === path));
      });

    this.router.events.subscribe(ev => {
      if (ev instanceof NavigationEnd) {
        this.buttons = this.navigationButtonService.onUrlChange(ev.url, this.buttons);
      }
    });
  }

  onButtonClick(button: NavigationButton) {
    this.router.navigate(this.navigationButtonService.getNavigationCommands(button));
    this.buttons.forEach(b => b.isSelected = (b.route === button.route));
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/navigation-panel/navigation-panel.component.ts